import {Button, Container, Form} from "react-bootstrap";
import Password from "../components/Password";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";
import React, {useState} from "react";
import MiniLoader from "../components/MiniLoader";
import axios from "axios";

const RecoveryPassword = () => {
    const { t } = useTranslation();
    document.title=t("Recovery Password")
    const history = useHistory();

    const [loader, setLoader] = useState(false)

    let newPassword = async (e) => {
        e.preventDefault()
        let passwordValidation = localStorage.getItem('newPasswordValidation')
        localStorage.removeItem('newPasswordValidation')

        if (passwordValidation === "true") {
            setLoader(true)
            if (!localStorage.getItem('emailVerifyToken')) {
                history.push('users/verify-email');
                toast(t("The security code has expired"), {type: "error"})
            }
            else {
                try {
                    let token = localStorage.getItem('emailVerifyToken')
                    // console.log(token)
                    await axios.post('/api/v1.0/users/recovery-password/', {
                        'token': token,
                        'password': e.target.password.value,
                        'confirm_password': e.target.confirm_password.value,
                    })
                    localStorage.removeItem('emailVerifyToken')
                    history.push('/login')
                    toast(t("The password has been changed. Now you can log in"), {type: "success"})
                }
                catch (error) {
                    // console.log(error.response.data)
                    toast(t("The new password is the same as the old one"), {type: "error"})
                    setTimeout(() => {setLoader(false)}, 200)
                }
                finally {
                    setTimeout(() => {setLoader(false)}, 200)
                }
            }
        }
    }

    return (
        <div className="auth-card">
                <h2>{t("Create a")} <span className="color">{t("New Password")}</span></h2>
                    <Form onSubmit={newPassword} className={loader ? "hide" : ""}>
                        <Password/>
                        <Button variant="green" type="submit">
                            {t("Save changes")}
                        </Button>
                    </Form>
                    { !loader ? "" : (
                        <div className="center-block">
                            <center>
                                <MiniLoader />
                            </center>
                        </div>)
                    }
            </div>
    )
}

export default RecoveryPassword
